import { render, staticRenderFns } from "./PaymentCardsAddCardButton.vue?vue&type=template&id=4beac008&scoped=true&funtional=true&"
import script from "./PaymentCardsAddCardButton.vue?vue&type=script&lang=js&"
export * from "./PaymentCardsAddCardButton.vue?vue&type=script&lang=js&"
import style0 from "./PaymentCardsAddCardButton.vue?vue&type=style&index=0&id=4beac008&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4beac008",
  null
  
)

export default component.exports